import {
defineCustomElement,
MediaPlyrLayoutElement
} from "vidstack/elements";

defineCustomElement(MediaPlyrLayoutElement);